import { motion } from "framer-motion";
import { ArrowLeft, Plug, Youtube, Linkedin, Twitter, Instagram, Facebook, Video } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";

export default function Integrations() {
  const navigate = useNavigate();
  
  const platforms = [
    { name: "YouTube", icon: Youtube, color: "text-red-500", status: "Live", description: "Upload and manage video content" },
    { name: "LinkedIn", icon: Linkedin, color: "text-blue-500", status: "Live", description: "Post to profiles and company pages" },
    { name: "Twitter/X", icon: Twitter, color: "text-sky-400", status: "Live", description: "Tweet and engage with followers" },
    { name: "Instagram", icon: Instagram, color: "text-pink-500", status: "Coming Soon", description: "Share photos and reels" },
    { name: "Facebook", icon: Facebook, color: "text-blue-600", status: "Coming Soon", description: "Post to pages and groups" },
    { name: "TikTok", icon: Video, color: "text-white", status: "Coming Soon", description: "Create viral short-form videos" },
  ];
  
  return (
    <div className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <Plug className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-bold">Integrations</h1>
          </div>
          
          <p className="text-muted-foreground mb-8">
            Connect YASNO to your favorite social media platforms and let our AI handle your marketing across all channels.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {platforms.map((platform, index) => (
              <motion.div
                key={platform.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="glass-card border-white/10 hover:border-primary/30 transition-all">
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center">
                          <platform.icon className={`w-6 h-6 ${platform.color}`} />
                        </div>
                        <div>
                          <h3 className="font-semibold">{platform.name}</h3>
                          <p className="text-sm text-muted-foreground">{platform.description}</p>
                        </div>
                      </div>
                      <span className={`text-xs px-2 py-1 rounded-full ${
                        platform.status === "Live" 
                          ? "bg-green-500/20 text-green-400" 
                          : "bg-yellow-500/20 text-yellow-400"
                      }`}>
                        {platform.status}
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
          
          <div className="mt-8 p-6 glass border border-white/10 rounded-xl">
            <h2 className="text-xl font-semibold mb-3">Need a custom integration?</h2>
            <p className="text-muted-foreground mb-4">
              We're always adding new platforms. Contact us if you need a specific integration for your marketing needs.
            </p>
            <Button onClick={() => navigate("/contact")}>Contact Us</Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
